<template>
    <div class="actionables-widget-card d-flex justify-content-between align-items-center" role="button" @click="OpenActionables">
        <div> {{ $t('Actionables') }} </div>
        <div><span class="badge actionables-widget-badge border">{{ count }}</span></div>
    </div>
</template>
    
<script>

import {DashboardGetProjectActionablesFirstPart,DashboardGetProjectActionables} from '@/actions/projectActions.js'
export default {
    name : 'ActionablesWidget',
    props : ['projectInfo'],
    mounted : async function(){
        const self = this
        const getData = await DashboardGetProjectActionablesFirstPart(self.projectInfo._id)
        let data = getData.messages

        if(getData.cleared){
            const getDotNetData = await DashboardGetProjectActionables(self.projectInfo._id)
            if(getDotNetData)
                data.push(...getDotNetData.data)
        }

        self.count = data.filter(u=>!u.status).length
    },
    data(){
        return {
            count : 0,
        }
    },
    methods : {
        OpenActionables(){
            this.$router.push({name : 'ActionableList', params : {id : this.projectInfo._id}})
        }
    }
} 
</script>

<style scoped>
.actionables-widget-card {
    min-height: 2.75rem;
    border-radius: 0;
    background: #45cf86;
    border: 1px solid #45cf86;
    color: #ffffff;
    cursor: pointer;
    margin: 0;
    padding: 0 1rem;
    transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;
}

.actionables-widget-card:hover,
.actionables-widget-card:focus {
    background: #2fba70;
    border-color: #2fba70;
    box-shadow: 0 0.5rem 1rem rgba(69, 207, 134, 0.18);
}

.actionables-widget-card > div:first-child {
    font-weight: 600;
}

.actionables-widget-badge {
    display: inline-flex;
    min-width: 2.5rem;
    height: 1.25rem;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    background: rgba(239, 255, 247, 0.18) !important;
    border-color: #effff7 !important;
    color: #ffffff;
    font-size: 0.7rem;
    font-weight: 700;
    line-height: 1;
    padding: 0 0.55rem;
}
</style>
